export const selectBidList = (state) => state.bid;
